import React from "react";
import Curation from "../../Components/B2B/Curation";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const CurationPage = ({ match, location }) => {
  const query = queryString.parse(location.search);

  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <Curation query={query} />
    </React.Fragment>
  );
};

export default CurationPage;
